<template>
  <span
    class="product-awards__show-less-button"
    @click="emitClose"
  />
</template>

<script lang="ts">
  import pigeon from '../../utilities/js/pigeon/pigeon';
  import {Options, Vue} from 'vue-property-decorator';

  @Options({
    name: 'product-awards-show-less-button',
  })
  export default class ProductAwardsShowLessButton extends Vue {
    emitClose() {
      pigeon.publish('productAwards:showLess');
    }
  }
</script>
